export default function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_has.js
// module id = 66
// module chunks = 1